import { Box, CircularProgress } from '@mui/material';

const CenterLoader = () => (
   <Box
      sx={{
        position: 'relative',
        width: "100%",
        height: "100%",
          display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      }}
    >
      {/* Background ring (AntD faint circle) */}
      {/* <CircularProgress
        variant="determinate"
        value={100}
        thickness={4}
        sx={{
          color: '#e6f4ff', // AntD background ring
          position: 'absolute',
          left: 0,
        }}
      /> */}

      {/* Animated spinner */}
      <CircularProgress
        variant="indeterminate"
        thickness={4}
        sx={{
          color: '#1677ff', // AntD blue
          animationDuration: '0.8s', // smoother & faster
        }}
      />
    </Box>
);

export default CenterLoader;
